export function scrollable() {
    
    return {
        
        restrict: 'A',
        link: function ($scope, $element, attrs, ...etc) {
            
            const iswk = window.navigator.userAgent.toLowerCase().indexOf("webkit");
            
            if (iswk !== -1) {
                
                $element.css('overflow-y', 'auto');
                
                return;
            }
            
            $element.css('overflow', 'hidden');
            
            return $scope.$watch(() => {
                
                return $element.prop('scrollHeight');
                
            }, (newValue, oldValue) => {
                
                $element.slimScroll({
                    alwaysVisible: true,
                    color: '#85b9b9',
                    distance: '6px',
                    height: '144px',
                    size: '6px',
                });
            });
        }
    }
}


// WEBPACK FOOTER //
// ./src/ui/directives/scrollable.directive.js